import "./index.sass";

interface VideoMEFProps {
  src: string;
}

const VideoMEF = ({ src }: VideoMEFProps) => {
  return (
    <div id="video-mef">
      <div className="video-mef">
        <video controls style={{ maxHeight: "var(--height-635)" }} src={src} />
      </div>
    </div>
  );
};

export default VideoMEF;
